import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';
import { trigger, animate, style, transition } from '@angular/animations';
import { Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SidebarItem {
  name: string;
  icon?: string;
  img?: Observable<string>;
  routerLink?: string[];
  items?: Observable<SidebarItem[]>;
  class?: string;
  class_a?: string;
  expanded?: boolean;
  active?: boolean;
  visible?: Observable<boolean>;
  disabled?: Observable<boolean>;
  badge?: Observable<boolean>;
  fn?: () => void;
  divider?: boolean;
}

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrls: ['./sidebar-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('expandDown', [
      transition(':enter', [
        style({ height: '0', opacity: 0 }),
        animate('100ms', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1 }),
        animate('100ms', style({ height: '0', opacity: 0 })),
      ]),
    ]),
  ],
})
export class SidebarItemComponent implements OnInit, OnDestroy {
  @Input() item: SidebarItem;
  @Output() toggle = new EventEmitter();
  @Output() clicked = new EventEmitter();
  version = environment.version;
  private onDestroy = new Subject<void>();

  constructor() {}

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  ngOnInit(): void {}

  onClick(submenuItem?: SidebarItem): void {
    const item = submenuItem || this.item;

    if (item.items) {
      item.expanded = !item.expanded;
    }

    // Only close others if expanding item (not for subitems)
    if (item === this.item) {
      this.toggle.emit(item);
    }

    if (typeof item.fn === 'function') {
      this.clicked.emit();
      item.fn();
    }
  }

  onClickSubmenu(item: SidebarItem): void {
    this.onClick(item);
  }
}
